import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Predmet} from '../model/predmet';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-predmet-detail',
    templateUrl: './predmet-detail.component.html',
    styleUrls: ['./predmet-detail.component.css'],
    standalone: false
})
export class PredmetDetailComponent implements OnInit {

  predmet: Predmet;
  titulok: string;
  isStatnicovyPredmet: boolean;

  constructor(
    public dialogRef: MatDialogRef<PredmetDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {predmet: Predmet},
    private translate: TranslateService
  ) {
    this.predmet = data.predmet;
  }

  ngOnInit(): void {
    this.isStatnicovyPredmet = ['S', 'O'].includes(this.predmet.kodTypPredmetu);
    this.titulok = this.getTitulok(this.isStatnicovyPredmet);
  }


  private getTitulok(isStatnicovyPredmet: boolean) {
    if (isStatnicovyPredmet) {
      return this.translate.instant('Detail štátnicového predmetu');
    }
    else {
      return this.translate.instant('Detailné informácie z Informačného listu');
    }
  }
}
